module.exports = __webpack_public_path__ + "img/video-pre.a523a2b5.jpg";